import type { ValueOf } from 'type-fest';

import { DETAILS_SETTINGS_MODAL_TYPES } from 'constants/all';

const ACTION_TYPE_PREFIX =
  'modules/common/modals/detailsSettingsModal/' as const;

export const ACTION_TYPES = {
  detailsSettingsModalClose: `${ACTION_TYPE_PREFIX}DETAILS_SETTINGS_MODAL_CLOSE`,
  detailsSettingsModalConfirm: `${ACTION_TYPE_PREFIX}DETAILS_SETTINGS_MODAL_CONFIRM`,
  detailsSettingsModalOpen: `${ACTION_TYPE_PREFIX}DETAILS_SETTINGS_MODAL_OPEN`,
} as const satisfies Record<string, `${typeof ACTION_TYPE_PREFIX}${string}`>;

export const detailsSettingsModal = {
  open: ({
    isMultipleItems,
    mode,
    filenames = [],
    bulkUpdateQuoteItemIds,
  }: {
    isMultipleItems: boolean;
    mode: ValueOf<typeof DETAILS_SETTINGS_MODAL_TYPES>;
    filenames?: string[];
    /** When opening bulk root-component / BOM edit, used to load `fieldSuggestions` for MaterialSelector. */
    bulkUpdateQuoteItemIds?: number[];
  }) => ({
    type: ACTION_TYPES.detailsSettingsModalOpen,
    payload: { isMultipleItems, mode, filenames, bulkUpdateQuoteItemIds },
  }),
  close: () => ({
    type: ACTION_TYPES.detailsSettingsModalClose,
  }),
  confirm: ({
    bomQuantity,
    estimatorId,
    exportControlled,
    finishOpDefIds,
    material,
    partNumber,
    process,
    quantities,
    revision,
    supplierMaterial,
    isAssembly,
    shouldMergeIdenticallyNamedFiles,
  }: {
    partNumber?: string;
    revision?: string;
    quantities: number[];
    bomQuantity?: string | number;
    estimatorId?: number;
    exportControlled: boolean;
    finishOpDefIds?: number[];
    process: number | null;
    material: string | number | null;
    supplierMaterial: string | number | null;
    isAssembly: boolean;
    shouldMergeIdenticallyNamedFiles: boolean;
  }) => ({
    type: ACTION_TYPES.detailsSettingsModalConfirm,
    payload: {
      bomQuantity,
      estimatorId,
      exportControlled,
      finishOpDefIds,
      material,
      partNumber,
      process,
      quantities,
      revision,
      supplierMaterial,
      isAssembly,
      shouldMergeIdenticallyNamedFiles,
    },
  }),
} as const;
